module.exports = __webpack_public_path__ + "static/media/male_kid.0f7608f3.png";